import type { DeliveryMethod, Product } from '@libs/common-types';

/**
 * True when the delivery method supports at least one of one-time or autoship purchase
 * (replaces legacy `isEnabled`).
 */
export function isPurchaseOptionAvailable(
    method: DeliveryMethod | Pick<DeliveryMethod, 'availablePurchaseOptions'> | undefined
): boolean {
    const opts = method?.availablePurchaseOptions;
    if (!opts) return false;
    return opts.oneTime || opts.autoship;
}

/**
 * True when any fulfillment path allows autoship purchase
 * (replaces legacy `Product.autoship.isEnabled`).
 */
export function isProductAvailableForAutoship(product: Pick<Product, 'deliveryMethods'>): boolean {
    const { STH, BOPIS, SDD } = product.deliveryMethods;
    return (
        Boolean(STH.availablePurchaseOptions?.autoship) ||
        Boolean(BOPIS.availablePurchaseOptions?.autoship) ||
        Boolean(SDD.availablePurchaseOptions?.autoship)
    );
}
